// src/utils/setupAdminUser.js
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Set up admin user profile for the current authenticated user
 */
export const setupAdminUser = async (user) => {
  if (!user || !db) {
    throw new Error('User not authenticated or Firebase not available');
  }

  try {
    console.log('🔧 Setting up admin user profile for:', user.email);

    // Check if profile already exists
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    const adminProfile = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName || user.email.split('@')[0],
      role: 'admin',
      firstName: user.displayName?.split(' ')[0] || 'Admin',
      lastName: user.displayName?.split(' ')[1] || 'User',
      phone: '',
      department: 'Administration',
      permissions: [
        'manage_users',
        'manage_clients',
        'manage_appointments',
        'manage_invoices',
        'manage_settings',
        'manage_tenants',
        'view_reports'
      ],
      isActive: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      createdBy: user.uid
    };

    // If profile exists, merge with existing data but ensure admin role
    if (userDoc.exists()) {
      const existingData = userDoc.data();
      console.log('📝 Updating existing profile with admin permissions');
      
      await setDoc(doc(db, 'users', user.uid), {
        ...existingData,
        role: 'admin',
        permissions: adminProfile.permissions,
        updatedAt: new Date().toISOString()
      }, { merge: true });
    } else {
      console.log('✨ Creating new admin profile');
      await setDoc(doc(db, 'users', user.uid), adminProfile);
    }

    console.log('✅ Admin user profile created successfully');
    return adminProfile;

  } catch (error) {
    console.error('❌ Failed to setup admin user:', error);
    throw error;
  }
};

// Make it available in browser console for debugging
if (typeof window !== 'undefined') {
  window.setupAdminUser = setupAdminUser;
}
